export const mapInit = () => {
    const mapElement = document.getElementById('snazzymap');
    if (!mapElement) return;

    // Load Leaflet CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    link.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
    link.crossOrigin = '';
    document.head.appendChild(link);

    // Load Leaflet JS
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    script.crossOrigin = '';
    script.async = true;

    script.onload = () => {
        // Coordinates for Akasaka Biz Tower
        const lat = 35.673049;
        const lng = 139.736279;
        const googleMapsUrl = `https://www.google.com/maps/place/%E8%B5%A4%E5%9D%82Biz%E3%2582%25BF%E3%2583%25AF%E3%2583%25BC/@${lat},${lng},17z`;

        const map = L.map('snazzymap', {
            center: [lat, lng],
            zoom: 16,
            scrollWheelZoom: false,
            zoomControl: false, // Disable default top-left
            attributionControl: false
        });

        // Move Zoom control to bottom-right
        L.control.zoom({
            position: 'bottomright'
        }).addTo(map);

        // CartoDB Positron (Ultra Light with Labels style)
        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; CARTO',
            subdomains: 'abcd',
            maxZoom: 20
        }).addTo(map);

        // Custom Icon
        const customIcon = L.icon({
            iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
            iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
            shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });

        const marker = L.marker([lat, lng], { icon: customIcon }).addTo(map);

        // Custom Info Box Control (Top Left)
        const InfoControl = L.Control.extend({
            onAdd: function (map) {
                const div = L.DomUtil.create('div', 'map-info-card');
                div.innerHTML = `
                    <div class="card-top">
                        <div>
                            <h2>赤坂Bizタワー</h2>
                            <div class="address">日本、〒107-6301 東京都港区赤坂<br>5丁目3-1</div>
                        </div>
                        <a href="${googleMapsUrl}" target="_blank" class="directions-btn">
                            <svg class="directions-icon" viewBox="0 0 24 24">
                                <path fill="#1a73e8" d="M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"/>
                            </svg>
                            <span>ルート</span>
                        </a>
                    </div>
                    <div class="rating">
                        <span class="score">3.8</span>
                        <span class="stars">★★★★☆</span>
                        <span class="count">3,000 件のクチコミ</span>
                    </div>
                    <div class="actions">
                        <a href="${googleMapsUrl}" target="_blank" class="large-map-link">拡大地図を表示</a>
                    </div>
                `;
                // Prevent click propagation to map
                L.DomEvent.disableClickPropagation(div);
                return div;
            },
            onRemove: function (map) {
                // Nothing to do here
            }
        });

        const infoControl = new InfoControl({ position: 'topleft' });
        infoControl.addTo(map);
    };

    document.head.appendChild(script);
};
